// Footer.js
import styles from './Footer.module.css'
import { useLanguage } from '../contexts/LanguageContext'
import getData from './Model'

function Footer(){
    const { language } = useLanguage()
    const ui = getData('ui', language)
    const currentYear = new Date().getFullYear()
    const nextYear = currentYear + 1
    
    return (
        <div className={styles.Footer}>
            {ui.footer} {currentYear}-{nextYear}
        </div>
    )
}

export default Footer